import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { MatTableDataSource, PageEvent, Sort, MatSelect, MatSort, MatExpansionPanel, MatSnackBar } from '@angular/material';
import { Subscription } from 'rxjs';
import { Moment } from "moment";
import * as moment from 'moment';
import { Usuario, TipoUsuario } from '../../../interfaces/usuario';
import { TareaService } from '../../../providers/tarea.service';
import { PermisoService } from '../../../providers/permiso.service';
import { UsuarioService } from '../../../providers/usuario.service';
import { VolverService } from '../../../providers/volver.service';
import { FormatDatePipe } from '../../../pipes/transforms/format-date.pipe';
import { BooleanTraductorPipe } from '../../../pipes/transforms/boolean-traductor.pipe';
import { Telefono } from '../../../components/telefono/telefono.component';
import { Tarea, TareaTipo } from '../../../interfaces/tarea';
import { Cotizacion } from '../../../interfaces/cotizacion';
import { Entidad } from '../../../interfaces/entidad';
import { TareaResponsable } from '../tarea-responsables/tarea-responsable/tarea-responsable';

@Component({
  selector: 'app-ver-tareas',
  templateUrl: './ver-tareas.component.html',
  styleUrls: ['./ver-tareas.component.scss']
})
export class VerTareasComponent implements OnInit {
  title = "Tareas";
  actualizarTablaTimeout: any; // prevenir muchos llamados consecutivos al webserver
  flag_primera_carga: boolean = true; // primera solicitud a traer datos
  cargandoTimeout: any;
  cargando: boolean = true; // para mostrar el progress-bar luego de un tiempo de busqueda
  tablaTareasColumnas = ['fechaTarea', 'fechaNotificacion', 'titulo', 'descripcion', 'asignacion', 'completada'];
  tareasDataSource = new MatTableDataSource();
  sort: Sort = { active: '', direction: '' };
  page: PageEvent = new PageEvent();
  getTareasSuscripcion = new Subscription();
  tareasCount: number = 0;
  usuarios: Usuario[] = [];
  cargandoUsuarios: boolean = false;
  tareaEstados: Array<string> = ['A VENCER', 'TERMINADA', 'VENCIDA'];
  @Input() filtrosExternos: any = {}; // filtros que se aplican según el lugar donde se muestran las incidencias
  filtros: any = {
    generico: '',
    fechaDesde: '',
    fechaHasta: '',
    tareasAsignadas: '',
    estado: '',
    responsable: '',
    numero: ''
  };
  @ViewChild(MatSort) matSort: MatSort;
  @ViewChild('filtroTareasAsignadas') set filtroTareasAsignadas(v: MatSelect) {
    if (typeof v != 'undefined')
      v.compareWith = (a, b) => { return a && b && a == b; };
  };
  @ViewChild('filtroEstadoTarea') set filtroEstadoTarea(v: MatSelect) {
    if (typeof v != 'undefined')
      v.compareWith = (a, b) => { return a && b && a == b; };
  };
  @ViewChild('filtroTareaResponsable') set filtroTareaResponsable(v: MatSelect) {
    if (typeof v != 'undefined')
      v.compareWith = (a, b) => { return a && b && a.IdUsuario == b.IdUsuario; };
  };
  // si tiene algún elemento, es que se está cargando algo para los filtros
  cargandoFiltros = [];
  tieneFiltrosOrdenPaginado: boolean = false;
  // true si hay almenos un filtro activo
  panelConFiltroActivo = false;
  @ViewChild('filtrosPanel') set filtrosPanel(v: MatExpansionPanel) {
    if (typeof v != 'undefined') {
      setTimeout(() => {
        this.checkPageState();
        if (this.panelConFiltroActivo) {
          v.open();
        }
      }, 0);
    }
  };
  descargandolistado: boolean = false;

  constructor(
    private tareaService: TareaService,
    private permisoService: PermisoService,
    private usuarioService: UsuarioService,
    private volverSv: VolverService,
    private snackBar: MatSnackBar,
    private datePipe: FormatDatePipe,
    private booleanPipe: BooleanTraductorPipe
  ) {
    this.permisoService.tienePermiso('TAREA-ACCIONES').then(tienePermiso => {
      if (tienePermiso) {
        this.tablaTareasColumnas.push('acciones');
      }
    });
  }

  ngOnInit() {
    this.traerUsuarios();

    // set valores iniciales
    if (this.volverSv.usaronBotonVolver()) {
      this.restaurarPageState();
    } else {
      this.reiniciarPageState();
    }
  }

  /**
   * limpia las variables de page state
   * y luego restaura el estado al estado inicial
   */
  reiniciarPageState() {
    this.limpiarPageState();
    this.restaurarPageState();
  }

  /**
   * olvidar el estado de la página
   */
  limpiarPageState() {
    // filtros
    localStorage.setItem('ver_tareas_filtros', null);
    // paginado
    localStorage.setItem('ver_tareas_paginado', null);
    // sort
    localStorage.setItem('ver_tareas_sort', null);
  }

  /**
   * recuerda el estado de la página por si vuelven a ingresar
   * y hay que mostrarla tal cual como estaba
   */
  recordarPageState() {
    // filtros
    localStorage.setItem('ver_tareas_filtros', JSON.stringify(this.filtros));
    // paginado
    localStorage.setItem('ver_tareas_paginado', JSON.stringify(this.page));
    // sort
    localStorage.setItem('ver_tareas_sort', JSON.stringify(this.sort));
  }

  /**
   * restaudar la página al estado en que estaba
   */
  restaurarPageState() {
    // filtros
    let localFiltros = JSON.parse(localStorage.getItem('ver_tareas_filtros'));
    if (localFiltros != null) {
      this.filtros = localFiltros;
    } else {
      for (let propiedad in this.filtros) {
        this.filtros[propiedad] = '';
      }
    }
    // paginado
    let localPaginado = JSON.parse(localStorage.getItem('ver_tareas_paginado'));
    if (localPaginado != null) {
      this.page = localPaginado;
    } else {
      this.page.pageIndex = 0;
      this.page.pageSize = +localStorage.getItem('ver_tareas_paginado_size') || 10;
      this.page.length = 0;
    }
    // sort
    let localSort = JSON.parse(localStorage.getItem('ver_tareas_sort'));
    if (localSort != null) {
      // para el sort tenemos que hacerlo con un "set" porque arregla un bug de "matSort"
      this.setActiveSortProgrammatically(localSort.active, localSort.direction);
    } else {
      this.setActiveSortProgrammatically('fechaTarea', 'desc');
    }
    this.actualizarTabla();
  }

  /**
   * revisa las variables de page state para ver
   * si hay almenos una aplicada ya sea filtrado, paginado u ordenamiento
   */
  checkPageState(): boolean {
    this.tieneFiltrosOrdenPaginado = false;
    // checkear si hay almenos un filtro aplicado
    this.panelConFiltroActivo = false;
    for (let propiedad in this.filtros) {
      if (this.filtros[propiedad]) {
        this.tieneFiltrosOrdenPaginado = true;
        this.panelConFiltroActivo = true;
        break;
      }
    }
    // checkear si hay paginado
    if (this.page.pageIndex != 0) {
      this.tieneFiltrosOrdenPaginado = true;
    }
    // checkear si hay ordenamiento
    if (this.sort.active != '' && (this.sort.active != 'fechaTarea' || this.sort.direction != 'desc')) {
      this.tieneFiltrosOrdenPaginado = true;
    }

    return this.tieneFiltrosOrdenPaginado;
  }

  /**
   * Para arreglar un bug de angular usamos esta funcion para ordenar
   */
  setActiveSortProgrammatically(active, direction): void {
    let interval = setInterval(() => {
      if (this.matSort) {
        clearInterval(interval);
        if (this.sort.active != active || this.sort.direction != direction) {
          this.sort = <MatSort>{
            active: active,
            direction: direction
          };
          this.matSort.sort({
            id: active,
            start: direction,
            disableClear: true
          });
          // ugly hack!
          const activeSortHeader = this.matSort.sortables.get(active);
          if (activeSortHeader) {
            activeSortHeader['_setAnimationTransitionState']({
              fromState: direction,
              toState: 'active'
            });
          }
        }
      }
    }, 0);
  }

  traerUsuarios(): void {
    this.cargandoUsuarios = true;
    this.cargandoFiltros.push(true);
    this.usuarios = <Usuario[]>[];
    this.usuarioService.getUsuarios(
      {
        page: null,
        pageSize: null
      },
      {
        sort: 'nombre',
        order: null
      },
      {
        generico: null
      }
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data && respuesta.data.usuarios) {
          respuesta.data.usuarios.forEach(usuario => {
            this.usuarios.push(
              new Usuario(
                usuario.id,
                usuario.usuario,
                usuario.email,
                <TipoUsuario>{
                  id: usuario.tipoUsuario.id,
                  descripcion: usuario.tipoUsuario.descripcion
                },
                null,
                usuario.nombre,
                usuario.apellido,
                new Telefono(usuario.telefono.pais, usuario.telefono.area, usuario.telefono.numero),
                +usuario.estado,
                usuario.puesto,
                !!+usuario.editable,
                !!+usuario.eliminable
              )
            );
          });
        }

        this.cargandoUsuarios = false;
        this.cargandoFiltros.pop();
      },
      () => {
        this.cargandoUsuarios = false;
        this.cargandoFiltros.pop();
      }
    );
  }

  fechaDesdeFilter = (d: Moment): boolean => {
    // lógica de la "fecha desde":
    // (hoy menos un año) <= (fecha desde) <= (fecha hasta || hoy más un año)   
    return d.isSameOrAfter(moment().subtract(1, 'year')) && d.isSameOrBefore(this.filtros.fechaHasta || moment().add(1, 'year'));
  }

  fechaHastaFilter = (d: Moment): boolean => {
    // lógica de la "fecha hasta":
    // (fecha desde || hoy menos un año) <= (fecha hasta) <= (hoy más un año)  
    return d.isSameOrAfter(this.filtros.fechaDesde || moment().subtract(1, 'year')) && d.isSameOrBefore(moment().add(1, 'year'));
  }

  onFiltro() {
    this.page.pageIndex = 0;
  }

  sortData(sort: Sort) {
    this.sort = sort;
    this.actualizarTabla();
  }

  onPage(pageEvent: PageEvent) {
    localStorage.setItem('ver_tareas_paginado_size', pageEvent.pageSize.toString());
    this.page = pageEvent;
    this.actualizarTabla();
  }

  actualizarTabla(): void {
    clearTimeout(this.actualizarTablaTimeout);
    this.actualizarTablaTimeout = setTimeout(() => {
      clearTimeout(this.cargandoTimeout);
      this.cargandoTimeout = setTimeout(() => { // mostrar cargando si tarda mas de algun tiempo de busqueda
        this.cargando = true;
      }, 750);

      if (this.getTareasSuscripcion && !this.getTareasSuscripcion.closed) {
        this.getTareasSuscripcion.unsubscribe();
      }

      this.recordarPageState();
      this.checkPageState();
      this.getTareasSuscripcion = this.tareaService
        .getTareas(
          {
            page: this.page.pageIndex,
            pageSize: this.page.pageSize
          },
          {
            sort: this.sort.active,
            order: this.sort.direction
          },
          Object.assign(this.filtrosExternos, this.filtros) // filtros del componente mas los filtros según donde se muestra el componente
        )
        .subscribe( // suscribimos una nueva busqueda
          respuesta => {
            if (respuesta.estado == 1 && respuesta.data) {
              if (respuesta.data.total) {
                this.tareasCount = respuesta.data.total;
              }

              var tareas: Tarea[] = []; // array de datos obtenidos  
              if (respuesta.data.tareas) {
                respuesta.data.tareas.forEach(tarea => {
                  tareas.push(
                    new Tarea(
                      tarea.IdTarea,
                      tarea.titulo,
                      tarea.fechaTarea,
                      tarea.fechaTarea ? moment(tarea.fechaTarea).format('HH:mm:ss') : null,
                      tarea.fechaNotificacion,
                      tarea.fechaNotificacion ? moment(tarea.fechaNotificacion).format('HH:mm:ss') : null,
                      tarea.descripcion,
                      tarea.cantidadResponsables,
                      tarea.totalCompletadasResponsables,
                      new Cotizacion(
                        tarea.cotizacion.IdCotizacion,
                        null,
                        new Entidad(
                          tarea.cotizacion.entidad.id,
                          tarea.cotizacion.entidad.razonSocial
                        ),
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        null,
                        tarea.cotizacion.numero,
                        tarea.cotizacion.fechaHoraModificacion,
                        null,
                        null,
                        null,
                        null
                      ),
                      new TareaTipo(
                        tarea.tipo.id,
                        tarea.tipo.descripcion
                      ),
                      (tarea.soyResponsable) ? new TareaResponsable(
                        tarea.soyResponsable.IdTareaResponsable,
                        new Usuario(
                          tarea.soyResponsable.usuario.IdUsuario,
                          tarea.soyResponsable.usuario.usuario,
                          null,
                          null,
                          null,
                          tarea.soyResponsable.usuario.nombre,
                          tarea.soyResponsable.usuario.apellido
                        ),
                        tarea.soyResponsable.fechaCompletada
                      ) : null
                    )
                  );
                });
              }
              
              this.tareasDataSource.data = tareas;
            }
          },
          () => {
            clearTimeout(this.cargandoTimeout); // ya no es necesario mostrar la progress bar
            this.cargando = false; // ocultar progress bar si se estaba mostrando
          },
          () => {
            clearTimeout(this.cargandoTimeout); // ya no es necesario mostrar la progress bar
            this.cargando = false; // ocultar progress bar si se estaba mostrando
          }
        );
    }, (this.flag_primera_carga ? 0 : 220));

    this.flag_primera_carga = false;
  }

  descargarListado() {
    this.descargandolistado = true;
    this.tareaService.getTareas(
      {
        page: 0,
        pageSize: this.tareasCount
      },
      {
        sort: this.sort.active,
        order: this.sort.direction
      },
      Object.assign(this.filtrosExternos, this.filtros)
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data && respuesta.data.tareas) {
          const titulos = [
            "Fecha tarea",
            "Fecha notificación",
            "Número cotización",
            "Razón social",
            "Título",
            "Descripción",
            "Estoy asignado",
            "Cantidad responsables",
            "Cantidad responsables completaron"
          ].join(';') + "\r\n";

          const datos = respuesta.data.tareas.map((a: any) => {
            return [
              this.datePipe.transform(a.fechaTarea, "YYYY-MM-DD HH:mm:ss", "DD/MM/YYYY HH:mm:ss"),
              this.datePipe.transform(a.fechaNotificacion, "YYYY-MM-DD HH:mm:ss", "DD/MM/YYYY HH:mm:ss"),
              a.cotizacion.IdCotizacion ? a.cotizacion.numero : '',
              a.cotizacion.IdCotizacion ? a.cotizacion.entidad.razonSocial : '',
              a.titulo,
              a.descripcion,
              this.booleanPipe.transform(a.soyResponsable != null ? true : false),
              a.cantidadResponsables,
              a.totalCompletadasResponsables
            ].join(';');
          }).join("\r\n");

          const csvConfig = "data:text/csv;charset=utf-8,%EF%BB%BF";
          let csvContent = titulos + datos;
          let downloadLink = document.createElement("a");
          downloadLink.href = csvConfig + encodeURI(csvContent);
          downloadLink.download = this.title + "_" + moment().format("YYYYMMDD_HHmmss") + ".csv";
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        } else {
          this.fallaDescargarListado();
        }
      },
      () => {
        this.descargandolistado = false;
        this.fallaDescargarListado();
      },
      () => {
        this.descargandolistado = false;
      }
    );
  }

  fallaDescargarListado() {
    this.snackBar.open('Lo sentimos, no se pudo descargar el listado', 'OK', { duration: 4750 });
  }

  ngOnDestroy() {
    if (this.getTareasSuscripcion && !this.getTareasSuscripcion.closed) {
      this.getTareasSuscripcion.unsubscribe();
    }
  }
}
